module.exports = __webpack_public_path__ + "static/media/expanding-brain.2c7401d3.png";